import { useEffect, useState } from "react";
import { CommonService } from "../services/CommonService";
import { IShippingConfig } from "./useShippingCalculator";

const DEFAULT_CONFIG: IShippingConfig = {
  minDistance: 1000,
  minTotal: 500,
  basePrice: 30,
  priceByMinute: 2,
  priceByKm: 5,
};

/**
 * Carga la configuración de precios de envío (config/pos), reemplazando
 * la lógica duplicada que antes vivía en Map.tsx y shippingQuote.tsx.
 */
export const usePosConfig = () => {
  const [config, setConfig] = useState<IShippingConfig>(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    CommonService.getPosConfig()
      .then((res) => {
        if (res.success && res.object) {
          const next = { ...DEFAULT_CONFIG };
          for (const item of res.object) {
            if (item.nombre === "shipping_base_price") next.basePrice = Number(item.valor);
            if (item.nombre === "shipping_distance_price_free") next.minDistance = Number(item.valor);
            if (item.nombre === "shipping_amount_price_free") next.minTotal = Number(item.valor);
            if (item.nombre === "shipping_time_price") next.priceByMinute = Number(item.valor);
            if (item.nombre === "shipping_distance_price") next.priceByKm = Number(item.valor);
          }
          setConfig(next);
        }
      })
      .catch((err) => {
        console.error("No se pudo cargar config/pos, usando valores por default", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return { config, loading };
};
